const TpCreditMemoReasonEnum = {
  BillingError: 'Billing Error',
  ClientDissatisfaction: 'Client Dissatisfaction',
  ClientGoodwill: 'Client Goodwill',
  BadDebt: 'Bad Debt',
  Other: 'Other',
  ContractDiscount: 'Contract Discount',
  LateFeeCredit: 'Late Fee Credit',
  TaxCredit: 'Tax Credit',
  ExcludedBCAssignments: 'Excluded BC Assignments',
  BankTransactionFee: 'Bank Transaction Fee',
  CurrencyExchangeVariation: 'Currency Exchange Variation',
};

export default TpCreditMemoReasonEnum;
